import React, { useState, useEffect } from 'react'

import { Box, Flex, P } from '../../../ui/acro'
import { SectionDivider } from '../../Home/SignedIn/common/styles'
import { SeriesBox, SeeMoreButton } from '../common/MyPracticeStyles'
import MyPracticeNotData from '../MyPracticeNotData'
import AloMovesAnimation from 'components_v2/Search/common/AloMovesAnimation'
import { LoadMore } from './Components/loadMoreItems'
import SortableList from 'components_v1/sortableList/SortableList'
import { SeriesCard } from 'components_v1/SchemaSectionRenderer/common/components'
import MyPracticeLeftFilter from '../MyPracticeLeftFilter'
// import ClassFinderNewFilteredList from '../../../components_v1/pageLevelComponents/classFinder/ClassFinderNewFilteredList'
import MyPracticeFilteredList from '../MyPracticeFilteredList'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { getPlanEntryGridState } from '../../../../javascript/redux/selectors/planEntries'
import { useUserContext } from 'context'

const Container = styled('div')`
  padding: 0 40px;
  .SelectedFiltersDisplay {
    margin: 0;
  }
  .SeriesComponentDetailsRow {
    .SortableList {
      @media (max-width: 1024px) {
        display: none;
      }
    }
  }
  @media (max-width: 1024px) {
    padding: 0;
    .ContentWrapper {
      @media (max-width: 1024px) {
        flex-direction: column;
      }
    }
    .SeriesCardContainer {
      justify-content: space-between;
    }
    .SeriesCardContainer-Grid {
      a {
        min-width: 150px !important;
      }
    }
  }
`
const sortOptions = ['date', 'oldest', 'recentlyViewed', 'az']

const MySeries = ({
  MySeries,
  optionChange,
  isLoading,
  perPage,
  page,
  setPerPage,
  setPage,
  fetchSeries,
  totalSeries,
  favoriteCallback,
  ...props
}) => {
  const initialSeries = MySeries
  const [isCompleted, setIsCompleted] = useState(true)
  const [order, setOrder] = useState('date')
  const { user } = useUserContext() || {}

  useEffect(() => {
    optionChange(order)
  }, [])
  const loadMore = () => {
    LoadMore(setPage, setPerPage, fetchSeries, 'series', page, perPage)
  }

  useEffect(() => {
    if (props.currentTab === 'series' && sortOptions.includes(props.order)) {
      onSortDropDownChange(props.order)
    }
  }, [props.order])

  const onSortDropDownChange = (sortOption) => {
    if (order !== sortOption) {
      setOrder(sortOption)
      optionChange(sortOption)
    }
  }

  useEffect(() => {
    const hasNoCards = !Array.isArray(MySeries) || MySeries?.length === 0
    const hasAllCards =
      Array.isArray(MySeries) && MySeries?.length === totalSeries

    setIsCompleted(hasNoCards || hasAllCards)
  }, [MySeries])

  return (
    <Container>
      {window.innerWidth > 1024 ? (
        <MyPracticeFilteredList
          includeFilters={props.includeFilters}
          dropdownOptions={props.dropdownOptions}
          preloadedFilters={props.preloadedFilters}
          baseUrl={props.baseUrl}
          withSubcategories={props.withSubcategories}
        />
      ) : null}
      <Flex gap='2%' className='ContentWrapper'>
        <MyPracticeLeftFilter
          withSubcategories={props.withSubcategories}
          // autopaginate={props.autopaginate}
          includeFilters={props.includeFilters}
          // planEntries={props.planEntries}
          preloadedFilters={props.preloadedFilters}
          baseUrl={props.baseUrl}
          dropdownOptions={props.dropdownOptions}
          parent_tab={'series'}
          currentTab={props.currentTab}
          fetchMyPracticeInfo={fetchSeries}
          selectedSeriesSortOption={order}
          totalCount={totalSeries}
          currentUser={user}
        />
        <Flex
          alignItems='center'
          flexDirection='column'
          justifyContent='flex-start'
          mt={['none', 'none', '1rem', '1rem']}
          width={['100%', '100%', '100%', '80%']}
        >
          <Flex
            flexDirection='row'
            justifyContent={[
              'space-between',
              'space-between',
              'space-between',
              'space-between'
            ]}
            pt={[0, 0]}
            pl={['5%', '20px', '10px', '5px']}
            pr={['5%', '20px', '10px', '5px']}
            width='100%'
            className='SeriesComponentDetailsRow'
          >
            <P alignSelf='flex-end' fontSize='16px'>
              {totalSeries} {totalSeries === 1 ? 'Program' : 'Programs'}
            </P>
            <SortableList
              sortableFields={sortOptions}
              order={order}
              onSort={onSortDropDownChange}
              sortLocation={'Classes'.toLowerCase()}
            />
          </Flex>
          {isLoading && <AloMovesAnimation />}
          {!isLoading && MySeries.length <= 0 && (
            <MyPracticeNotData option={'programs'} />
          )}
          {!isLoading && MySeries.length > 0 && (
            <SeriesBox
              id='Users-Series'
              inTrigger={MySeries && true}
              appear={true}
              className='SeriesCardContainer'
            >
              {initialSeries.map((serie) => {
                return (
                  <Box
                    key={serie.id}
                    width={
                      MySeries.length === 1
                        ? ['100%', '100%', 'auto', 'auto']
                        : props.layout === 'list'
                        ? ['100%', '33.33%', '33.33%', '33.33%']
                        : ['45%', '33.33%', '33.33%', '33.33%']
                    }
                    p={['1rem 0', '1rem', '2rem', '2rem']}
                    borderBottom={['1px solid #ECECEC', '0']}
                    style={{
                      position: 'relative'
                    }}
                    className={
                      props.layout === 'list'
                        ? 'SeriesCardContainer-List'
                        : 'SeriesCardContainer-Grid'
                    }
                  >
                    <SeriesCard
                      {...serie}
                      classCount={serie.workoutCount}
                      alignBox={'left'}
                      variantTitle='secondary'
                      variantSubtitle='secondary'
                      pb='20px'
                      favoriteCallback={favoriteCallback}
                      isGridView={props.layout === 'tile'}
                      membershipTier={user?.membershipTier}
                    />
                  </Box>
                )
              })}

              <SectionDivider />
            </SeriesBox>
          )}
          {!isLoading && !isCompleted && (
            <SeeMoreButton onClick={loadMore}>See More</SeeMoreButton>
          )}
        </Flex>
      </Flex>
    </Container>
  )
}

const mapStateToProps = (state) => {
  const planEntryGridState = getPlanEntryGridState(state)
  return {
    order: state.ui.planEntries.order,
    layout: planEntryGridState.layout
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(MySeries)
